import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import API from "../../services/api";
import { Alert } from "react-bootstrap";
import { t } from "@lingui/macro";

const validationSchema = Yup.object({
  email: Yup.string()
    .email(t`Invalid email address`)
    .required(t`Email is required`),
  password: Yup.string()
    .required(t`Password is required`)
    .min(6, t`Password must be at least 6 characters long`),
});

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async (values) => {
    const { email, password } = values;
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await API.post("/api/auth/public/login", {
        email,
        password,
      });
      console.log("Backend Response:", response);

      if (response.data.accessToken) {
        const token = response.data.accessToken;
        console.log("Received token:", token);

        sessionStorage.setItem("authToken", token);
        login(token);

        navigate("/home");
      } else {
        setErrorMessage(
          response.data.errorMessage ||
            t`Login failed. Please check your credentials and try again.`
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error Response:", error.response);

      if (error.response) {
        setErrorMessage(
          error.response.data?.errorMessage ||
            t`An error occurred. Please try again.`
        );
      } else {
        setErrorMessage(t`An error occurred. Please try again.`);
      }
    }
  };

  // OAuth handlers
  const handleGitHubLogin = () => {
    window.location.href = "/api/oauth2/authorization/github";
  };

  const handleFacebookLogin = () => {
    window.location.href = "/api/oauth2/authorization/facebook";
  };

  const handleGoogleLogin = () => {
    window.location.href = "/api/oauth2/authorization/google";
  };

  return (
    <div className="form-container">
      <h2>{t`Login`}</h2>

      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={validationSchema}
        onSubmit={handleLogin}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                {t`Email`} <span className="required">*</span>
              </label>
              <Field
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder={t`Enter your email`}
              />
              <ErrorMessage
                name="email"
                component="div"
                className="error-message"
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                {t`Password`} <span className="required">*</span>
              </label>
              <Field
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder={t`Enter your password`}
              />
              <ErrorMessage
                name="password"
                component="div"
                className="error-message"
              />
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting || loading}
            >
              {loading ? t`Logging in...` : t`Login`}
            </button>
          </Form>
        )}
      </Formik>

      <hr />

      <button className="oauth-btn" onClick={handleGitHubLogin}>
        <img
          src="/assets/images/logo/github-mark.png"
          alt="GitHub Login"
          className="oauth-logo"
        />
      </button>

      <button
        type="button"
        className="oauth-btn"
        onClick={handleFacebookLogin}
      >
        <img
          src="/assets/images/logo/Facebook_Logo_Primary.png"
          alt="Facebook Login"
          className="oauth-logo"
        />
      </button>

      <button type="button" className="oauth-btn" onClick={handleGoogleLogin}>
        <img
          src="/assets/images/logo/web_light_rd_na@1x.png"
          alt="Google Login"
          className="oauth-logo"
        />
      </button>
    </div>
  );
};

export default LoginPage;
